import { useEffect } from "react";
import { usePunditUserContext } from "@/react/contexts";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";
import { usePlanPageVariant } from "@/react/hooks/usePlanPageVariant";
import { useHelpWidgetContext } from "@circle-react/components/HelpWidget/context/HelpWidgetContext";
import { usePlans } from "@circle-react/components/SettingsApp/Plan/RegularPlan/PlansContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Loader } from "@circle-react-uikit/Loader";
import Features from "../Features";
import { PlanSelector } from "../PlanSelector";
import { TopSection } from "../TopSection";
import { MobileCheckoutOverlay } from "./MobileCheckoutOverlay";
import { PlanSummary } from "./PlanSummary";
import { SocialProof } from "./SocialProof";

export const PlansManagement = () => {
  const { isLoading: isCurrentCommunityLoading } = usePunditUserContext();
  const { isCurrentPlanLoading, selectedPlan } = usePlans();
  const { hideFab, showFab } = useHelpWidgetContext();
  const { isCompactLayout, isDesktopLayout, isMobileLayout } =
    usePlanPageVariant();

  const { trackEvent } = useEventsTracker();

  useEffect(() => {
    trackEvent("plan_settings.plans_page.visited", {});
  }, [trackEvent]);

  useEffect(() => {
    if (selectedPlan && isMobileLayout) {
      hideFab();
    } else {
      showFab();
    }

    return () => {
      showFab();
    };
  }, [selectedPlan, isMobileLayout, hideFab, showFab]);

  if (isCurrentPlanLoading || isCurrentCommunityLoading) {
    return <Loader variant="fullscreen" />;
  }

  const featuresAndProof = (
    <>
      <SocialProof scale={isMobileLayout ? 1.4 : 1} />
      <Features />
    </>
  );

  return (
    <>
      <div className="flex flex-col gap-10">
        <TopSection />
        <div className="flex md:gap-6">
          <div
            className={classNames(
              "flex flex-col gap-10",
              isCompactLayout ? "w-[550px]" : "w-[681px]",
            )}
          >
            <PlanSelector />
            {!isCompactLayout && featuresAndProof}
          </div>
          <div>{isDesktopLayout && <PlanSummary />}</div>
        </div>
        {isCompactLayout && (
          <div className="mx-auto flex max-w-[681px] flex-col gap-y-6">
            {featuresAndProof}
          </div>
        )}
      </div>
      <MobileCheckoutOverlay />
    </>
  );
};
